module.exports = __webpack_public_path__ + "img/advertising-slot.4a7a5f30.svg";